angular.module('pe4h').controller('CreateProposal', 
function($scope, $http, $q, $state, configuration, Upload, StripeCheckout, LoginService, $location) {

	// Parent scope should define $scope.project
	$scope.charLeft = 2000;
	$scope.Estimation = {
		hourly: "hourly",
		fixed: "fixed",
		range: "range"
	}
	$scope.EstimationType= $scope.Estimation.fixed; //1: Hourly, 2: Fixed, 3: Range

	$scope.isRangeInvalid= false;
	$scope.RangeError= '';
	$scope.proposal = {
		OnlyValidate: true,
		ProjectId: $scope.project.Id,
		Estimate: undefined,
		LowestRange: undefined,
		HighestRange: undefined,
		Hourly: false,
		Description: "",
		PaymentsToken: "",
		Attachment: undefined
	}
	$scope.agreement = false;

	$scope.file = null;

	var handler = StripeCheckout.configure({});

	var checkoutOptions = {
		description: "",
		amount: 1999,
	};

	$scope.projectClosed =  $scope.project.Status != 'open' || moment($scope.project.ClosingDate) < moment();
	$scope.projectFull = !$scope.project.IsPublic && $scope.project.ProposalsCount >= $scope.maxProposals;
 
	/*If the estimation type is hourly, proposal.Hourly must be true and LowestRange and HighestRange must be empty
		If the estimation type is fixed, proposal.Hourly must be false and LowestRange and HighestRange must be empty
		If the estimation type is a range, proposal.Hourly must be false and Estimate must be empty*/
	

	$scope.estimationTypeVerification = function() {
		switch($scope.EstimationType) {
			case $scope.Estimation.hourly:
				$scope.proposal.Hourly = true;
				$scope.proposal.LowestRange = null;
				$scope.proposal.HighestRange = null;
				$scope.isRangeInvalid= false;
				break;
			case $scope.Estimation.fixed:
				$scope.proposal.Hourly = false;
				$scope.proposal.LowestRange = null;
				$scope.proposal.HighestRange = null;
				$scope.isRangeInvalid= false;
				break;
			case $scope.Estimation.range:
				$scope.proposal.Estimate = null;
				$scope.proposal.Hourly = false;
				$scope.isRangeInvalid= true;
				break;
		}
	}

	$scope.validRangeVerification = function() {
		if (($scope.EstimationType === 'range') && ($scope.proposal.LowestRange != null) && 
			($scope.proposal.HighestRange != null) && (parseInt($scope.proposal.LowestRange) >= parseInt($scope.proposal.HighestRange))) {
				$scope.isRangeInvalid= true;
				$scope.RangeError= 'Please enter a valid range value'
		} else{
			$scope.isRangeInvalid= false;
			$scope.RangeError= ''
			if (isRangeNotEmpty($scope.proposal))
			{
				$http({
					url: configuration.webApi.invoices.calculateFee,
					method: "POST",
					data: $scope.proposal.HighestRange,
				  }).success(function(res, status, headers, config) {
					$scope.HighestRangeWithFee = res.totalWithFee;
					$scope.HighestRangeFee = res.fees;
					$http({
						url: configuration.webApi.invoices.calculateFee,
						method: "POST",
						data: $scope.proposal.LowestRange,
					  }).success(function(res, status, headers, config) {
						$scope.LowestRangeWithFee = res.totalWithFee;
						$scope.LowestRangeFee = res.fees;
					  }).error(function(error, status, headers, config) {
						$scope.RangeError= 'Please enter a valid range value'
					  });
				  }).error(function(error, status, headers, config) {
					$scope.RangeError= 'Please enter a valid range value'
				  });
			}
		}
	}

	$scope.calculateEstimateWithFee = function() {
		$http({
			url: configuration.webApi.invoices.calculateFee,
			method: "POST",
			data: $scope.proposal.Estimate,
		  }).success(function(res, status, headers, config) {
			$scope.EstimateWithFee = res.totalWithFee;
			$scope.EstimateFee = res.fees;
		  }).error(function(error, status, headers, config) {
			$scope.RangeError= 'Please enter a valid value'
		  });
	}

	$scope.updateCharLeft = function() {
	if ($scope.proposal.Description != undefined)
		$scope.charLeft = 2000 - $scope.proposal.Description.length;
	}

	$scope.createProposal = function(){

		// check user free proposals (do server request to get latest updated data) to minimize race conditions
		// and then validate we can still create proposal

		$http({
			url: configuration.webApi.users.users,
			method: "GET"
		}).success(function(userData, status, headers, config) {

			var createProposal = function(token){
				if(token){
					$scope.proposal.PaymentsToken = token;
				}
				else{
					$scope.proposal.PaymentsToken = undefined;
				}

				$scope.proposal.OnlyValidate = false;
				$scope.proposal.Attachment = $scope.file;
				var deferred = $q.defer();
				// create proposal on server
				Upload.upload({
			        url: configuration.webApi.proposals.proposals,
			        data: $scope.proposal,
			      })
			      .then(
			        function(data) {
			        	deferred.resolve(data);
						$scope.proposal.Id = userData.Id;
						$scope.proposalSentMessage = $scope.getMessagesParagraphs("proposalSentMessage");
						var hasOneMessage = $scope.proposalSentMessage && $scope.proposalSentMessage.length == 1
						var proposalSentMessage = hasOneMessage ? $scope.proposalSentMessage[0] : $scope.proposalSentMessage
						$scope.alertError("Proposal Sent!", proposalSentMessage, function(){
							// TODO: Do something. Reload project? Go to some page?
							$state.reload();//so that he can no longer post a proposal
						});
				    },
			        function(data) {
			          $scope.alertErrorFromServer(data);
			          deferred.reject(data);
			        },

			        //progress callback
			        function(evt) {
			          deferred.notify({
			            prog: evt.loaded / evt.total,
			            evt: evt
			          });
			        }
			    );
				return deferred.promise;

			}
			
			createProposal(null);

		}).error(function(error, status, headers, config) {
			$scope.alertErrorFromServer(error);
		});
	}

	$scope.removeFile = function(){
		$scope.file = null;
	};

    $scope.signUp = function() {
		LoginService.redirectSignUp($location.url());
	}

	$scope.logIn = function() {
		LoginService.redirectLogIn($location.url());
	} 
});

function isRangeNotEmpty(proposal){
	return (proposal.LowestRange && proposal.HighestRange && proposal.LowestRange.length != 0 && proposal.HighestRange.length != 0)
}
